import styled from 'styled-components'

export const CTAWrapper = styled.div`
  display: ${({ isEnable }) => (isEnable ? 'block' : 'none')};
  .ctabutton {
    background: #8bc34a;
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  height: auto;
  @media (min-width: 992px) {
    flex-direction: row;
  }
`

export const ContentWrapper = styled.div`
  @supports (display: flex) {
    flex: 1;
  }
  @media (min-width: 992px) {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    text-align: ${({ center }) => (center ? 'center' : 'left')};
  }
`
